import { defineComponent as _defineComponent } from 'vue'
import { Organization, OrganizationUser, SearchParams } from '@/modules/Organizations/types'
import {
  fetchOrganizationMembers,
  deleteOrganizationMemberById,
  addOrganizationMember,
} from '@/enitites/organization/api/endpoints'
import { ref, watch } from 'vue'
import UserChip from '@/shared/ui/chips/UserChip.vue'
import BKInput from '@/components/AppShared/BKInput.vue'
import { mdiMagnify, mdiMinusCircleOutline, mdiPlus } from '@mdi/js'
import { BKModal } from '@/shared/ui/modals'
import BKUserSelect from '@/components/BKUserSelect.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'OrganizationSettingsMembers',
  props: {
    org: null
  },
  setup(__props: any) {

const props = __props as { org: Organization };



const totalMembersCount = ref(props.org.totalMembers)
const orgMembers = ref<OrganizationUser[]>([])
const infiniteId = ref(Number(new Date()))
const loading = ref(false)
const showNotFound = ref(false)
const searchParams = ref<SearchParams>({
  pageNumber: 0,
  pageSize: 100,
  keyword: '',
})

const infiniteHandler = async ($state: { complete: () => void; loaded: () => void }) => {
  loading.value = true
  const data = await fetchOrganizationMembers(props.org.id, searchParams.value)
  loading.value = false

  if (!Array.isArray(data)) {
    $state.complete()
    return
  }
  searchParams.value.pageNumber += 1

  orgMembers.value = [...orgMembers.value, ...data]
  if (!orgMembers.value.length) showNotFound.value = true
  if (data.length < searchParams.value.pageSize) $state.complete()
  else $state.loaded()
}

const searchTimeout = ref<number | null>(null)

const refreshMembers = () => {
  searchParams.value.pageNumber = 0
  orgMembers.value = []
  showNotFound.value = false
  infiniteId.value += 1
}

const showAddModal = ref(false)
const userToAdd = ref<Record<string, unknown>[]>([])
const isAddingMember = ref(false)

const handleAddUser = async () => {
  if (!userToAdd.value.length || !userToAdd.value[0].id) return
  isAddingMember.value = true

  try {
    const res = await addOrganizationMember(props.org.id, userToAdd.value[0].id as number)
    if (res !== 'ok') return

    refreshMembers()
    totalMembersCount.value += 1
  } catch (e) {
    console.error(e)
  } finally {
    isAddingMember.value = false
    showAddModal.value = false
    userToAdd.value = []
  }
}

const handleDeleteUser = async (user: OrganizationUser) => {
  const res = await deleteOrganizationMemberById(props.org.id, user.id)
  if (res !== 'ok') return

  orgMembers.value = orgMembers.value.filter((u) => u.id !== user.id)
  totalMembersCount.value -= 1
}

watch(
  () => searchParams.value.keyword,
  () => {
    if (searchTimeout.value) clearTimeout(searchTimeout.value)
    searchTimeout.value = setTimeout(() => {
      searchParams.value.pageNumber = 0
      orgMembers.value = []
      showNotFound.value = false
      infiniteId.value += 1
      searchTimeout.value = null
    }, 600)
  }
)

return { __sfc: true,props, totalMembersCount, orgMembers, infiniteId, loading, showNotFound, searchParams, infiniteHandler, searchTimeout, refreshMembers, showAddModal, userToAdd, isAddingMember, handleAddUser, handleDeleteUser, UserChip, BKInput, mdiMagnify, mdiMinusCircleOutline, mdiPlus, BKModal, BKUserSelect }
}

})